import styled from 'styled-components';

export const Container = styled.div`
    display : flex;
    width: 100%
    margin :auto;
    overflow : auto;
    -webkit-user-select: none;
    -moz-user-select: none;
    -o-user-select: none;
    -ms-user-select: none;
    user-select: none;
    padding : ${props => props.padding ? props.padding : "0"};
    box-sizing :border-box;
`

export const Area = styled.div`
display : flex;
flex-direction : column;
`
export const LeftArea = styled(Area)`
  min-width : 800px;
  max-width : 800px;
  justify-content : space-between;
`;
export const RightArea = styled(Area)`
  position: relative;
  width : 300px;
  max-height: 480px;
  justify-content : space-between;
`;